import { once } from "@utils/general";

import { createUserId } from "@services/tracking/trackers/pageImpressionTracker";
import {
    TOOL_NEWSLETTER_CONTEXT,
    TOOL_NEWSLETTER_STEPS,
} from "@services/tracking/trackers/tools/newsletter/config";
import { trackNewsletterToolStep } from "@services/tracking/trackers/tools/newsletter/tracker";
import { EventTypes } from "@services/tracking/types/eventTypes";
import { StepVariables } from "@services/tracking/types/trackingInfo/toolStepTrackingInfo";

const trackNewsletterStepStarted = once(() => {
    trackNewsletterToolStep(
        EventTypes.ToolStep,
        TOOL_NEWSLETTER_STEPS.start,
        TOOL_NEWSLETTER_CONTEXT,
    );
});

const trackNewsletterStepSubmitted = (newsLetterResult: any) => {
    if (!newsLetterResult) return;

    const customerid = createUserId(newsLetterResult.email);
    const step: StepVariables = {
        ...TOOL_NEWSLETTER_STEPS.submit,
        result: {
            customerid: customerid,
            storeId: newsLetterResult.storeId,
        },
    };

    trackNewsletterToolStep(EventTypes.ToolStep, step, TOOL_NEWSLETTER_CONTEXT);
};

export { trackNewsletterStepSubmitted, trackNewsletterStepStarted };
